import { db } from '../firebase';
import { doc, setDoc, getDoc, arrayUnion, serverTimestamp } from 'firebase/firestore';

class ViewedCardsService {
  constructor() {
    this.viewedCache = new Map();
    this.userId = null;
  }

  setUserId(userId) {
    if (this.userId !== userId) {
      this.userId = userId;
      this.viewedCache.clear();
    }
  }

  async markCardAsViewed(cardId) {
    if (!this.userId || !cardId) return false;

    try {
      const userViewedRef = doc(db, 'users', this.userId, 'viewedContent', 'exploreCards');

      await setDoc(userViewedRef, {
        cardIds: arrayUnion(cardId),
        [`timestamps.${cardId}`]: serverTimestamp(),
        lastUpdated: serverTimestamp()
      }, { merge: true });

      this.viewedCache.set(cardId, true);
      return true;
    } catch (error) {
      console.error('Error marking card as viewed:', error);
      return false;
    }
  }

  async isCardViewed(cardId) {
    if (!this.userId || !cardId) return false;

    if (this.viewedCache.has(cardId)) {
      return this.viewedCache.get(cardId);
    }

    try {
      const userViewedRef = doc(db, 'users', this.userId, 'viewedContent', 'exploreCards');
      const docSnap = await getDoc(userViewedRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const isViewed = data.cardIds && data.cardIds.includes(cardId);
        this.viewedCache.set(cardId, isViewed);
        return isViewed;
      }

      return false;
    } catch (error) {
      console.error('Error checking if card is viewed:', error);
      return false;
    }
  }

  async getViewedCards() {
    if (!this.userId) return [];

    try {
      const userViewedRef = doc(db, 'users', this.userId, 'viewedContent', 'exploreCards');
      const docSnap = await getDoc(userViewedRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        return data.cardIds || [];
      }

      return [];
    } catch (error) {
      console.error('Error getting viewed cards:', error);
      return [];
    }
  }

  clearCache() {
    this.viewedCache.clear();
  }
}

const viewedCardsService = new ViewedCardsService();
export default viewedCardsService;